module.exports = __webpack_public_path__ + "static/media/w (35).d2f2851e.jpg";